<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
    </div>
    <div class="qrcode">
      <div class="bookcode" id="qrcode" ref="qrcode"></div>
    </div>
    <div class="download" @click="download">
      <i class="el-icon-download"></i>
      下载
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      shareValue: "",
    };
  },
  created() {},
  mounted() {
    this.shareValue = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww086cfff9688fbdfc&redirect_uri=http://qw.nvc-lighting.com.cn:8088/mobile/medal/publicWelfare/sign?id=${this.$route.query.id}&response_type=code&scope=SCOPE&state=STATE#wechat_redirect"`;
    this.qrcode();
  },
  methods: {
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
    // 生成二维码
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 170, //图像宽度
        height: 170, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.L,
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(this.shareValue);
    },
    // 下载二维码
    download() {
      html2canvas(this.$refs.qrcode).then((canvas) => {
        // this.$refs.addImage.append(canvas);//在下面添加canvas节点
        let link = document.createElement("a");
        link.href = canvas.toDataURL(); //下载链接
        link.setAttribute("download", "签到二维码.png");
        link.style.display = "none"; //a标签隐藏
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .qrcode {
    margin-top: 47%;
    display: flex;
    justify-content: center;
  }
  .download {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 50px;
    border: 1px solid #000;
    font-size: 12px * $zoom;
    // padding: 30px 50px;
    border-radius: 80px;
    width: 240px;
    height: 80px;
    margin: 80px auto 0;
    i {
      margin-right: 20px;
      font-size: 14px * $zoom;
    }
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
</style>
